import Meta from '@/assets/json/meta.json';

// 必ずmountedで呼び出すこと（各NODEにアクセスするため）

export default {
  methods: {
    metaSetForDefault(key = null) {
      if (key === null) {
        document.title = Meta.default.title;
        document.querySelector('meta[name="description"]').setAttribute('content', Meta.default.description);
      } else {
        document.title = Meta[key].title;
        document.querySelector('meta[name="description"]').setAttribute('content', Meta[key].description);
      }
    },
    metaSetForIndex() {
      document.title = Meta.index.title;
      document.querySelector('meta[name="description"]').setAttribute('content', Meta.index.description);
    },
    metaSetForDetail(pref, city, prop) {
      let title = Meta.detail.title;
      let description = Meta.detail.description;
      title = title.replace('{name}', prop.name);
      title = title.replace('{prefecture}', pref);
      title = title.replace('{city}', city);
      title = title.replace('{access}', prop.access_name_1);
      let ret;
      if (prop.kind === 'newly-house' || prop.kind === '新築一戸建て') {
        ret = '新築一戸建て';
      } else if (prop.kind === 'second-hand-house' || prop.kind === '中古一戸建て') {
        ret = '中古一戸建て';
      }
      title = title.replace('{kind}', ret);

      description = description.replace('{name}', prop.name);
      description = description.replace('{contactname}', prop.contact_name);
      description = description.replace('{prefecture}', pref);
      description = description.replace('{city}', city);
      description = description.replace('{access}', prop.access[0].name);

      document.title = title;
      document.querySelector('meta[name="description"]').setAttribute('content', description);
    },
    metaSetForList(area, kind = null) {
      let title;
      let description;
      title = Meta.searchList.title.replace('{area}', area);
      description = Meta.searchList.description.replace('{area}', area);
      title = title.replace('{area}', area);
      description = description.replace('{area}', area);
      if (kind !== null) {
        let type;
        if (kind === 1) {
          type = '新築';
        } else if (kind === 2) {
          type = '中古';
        } else {
          type = '';
        }
        title = title.replace('{kind}', type);
        description = description.replace('{kind}', type);
      }
      document.title = title;
      document.querySelector('meta[name="description"]').setAttribute('content', description);
    },

  },
};
